module.exports = __webpack_public_path__ + "img/dropdown-menu-product-2-1.7438f313.png";